import React from "react";
import { IoCloseSharp } from "react-icons/io5";
import LeasePDF from "./LeasePDF";

const ViewLeaseModal = (props) => {
  const { lease, handleModal } = props;

  return (
    <div className="w-screen h-screen fixed top-0 left-0 right-0 bg-white mt-20 z-10">
      <div
        className="flex items-center fixed left-0 right-0 h-10 bg-snappily-orange border-gray-300 
        border-t-1 text-xl text-white p-3 gap-x-3 mt-0 cursor-pointer z-20"
      >
        <div className="flex w-full justify-end z-50">
          <IoCloseSharp
            className="text-4xl rounded-full p-1 z-30"
            onClick={() => handleModal("viewLease")}
          />
        </div>
      </div>
      <div className="mt-10">
        <LeasePDF lease={lease} />
      </div>
    </div>
  );
};

export default ViewLeaseModal;
